import React, {Fragment} from 'react';
import {FormattedMessage} from 'react-intl';
import {APP_NAMES} from '../../constants';
import {useMapContext} from '../../context/MapContext';

const BathroomsElement = ({
    bathroomsFull,
    bathroomsHalf,
    bathroomsToiletOnly,
    bathrooms,
}) => {
    const mapContext = useMapContext();

    switch (mapContext.appName) {
        case APP_NAMES.TRIPBOARDS:
            return (
                <Fragment>
                    <div
                        className="MapHit__bathrooms MapHit__label"
                        aria-hidden="true"
                    >
                        {bathrooms}
                    </div>
                </Fragment>
            );
        default:
            if (bathroomsFull && bathroomsFull > 0) {
                return (
                    <Fragment>
                        <div
                            className="MapHit__bathrooms MapHit__label"
                            aria-hidden="true"
                        >
                            <FormattedMessage
                                id="bathroomsFullAbbreviationParam"
                                description={`bathrooms label`}
                                defaultMessage="{bathroomsFull} BA"
                                values={{
                                    bathroomsFull,
                                }}
                            />
                        </div>
                        <HalfBathElement
                            bathroomsHalf={bathroomsHalf}
                            bathroomsToiletOnly={bathroomsToiletOnly}
                        />
                    </Fragment>
                );
            }
            return null;
    }
};

const HalfBathElement = ({bathroomsHalf, bathroomsToiletOnly}) => {
    if (bathroomsHalf && bathroomsHalf > 0) {
        return (
            <HalfBathLabel
                id="bathroomsHalfAbbreviation"
                defaultMessage="HF BA"
                value={bathroomsHalf}
            />
        );
    } else if (bathroomsToiletOnly && bathroomsToiletOnly > 0) {
        return (
            <HalfBathLabel
                id="bathroomsToiletOnlyAbbreviation"
                defaultMessage="WC"
                value={bathroomsToiletOnly}
            />
        );
    }
    return null;
};

const HalfBathLabel = ({id, defaultMessage, value}) => {
    if (value && value > 0) {
        return (
            <div
                className="MapHit__halfbathrooms MapHit__label"
                aria-hidden="true"
            >
                <FormattedMessage
                    id={id}
                    description={'halfbathrooms label'}
                    defaultMessage={defaultMessage}
                />
            </div>
        );
    }
    return null;
};

export {BathroomsElement, HalfBathElement, HalfBathLabel};
